'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import React, { useEffect } from 'react';
import GoogleTagManager from '@/common/GoogleTagManager';
import useMicroFrontend from '@/common/MicroFrontEnds';
import ClientId from '~/constants/ClientId';
import { DeviceTypeProps } from '~/server-props/common/contracts';
import initDataDog from '~/utilities/datadog';

function getIsSafari(props: AppProps): boolean {
  const browserName = props.deviceTypeProps?.browserName ?? '';

  return browserName.includes('safari') || browserName.includes('ios');
}

export type AppProps = {
  clientId: ClientId;
  correlationId: string;
  dataDogReplaySampleRate?: number;
  dataDogSampleRate?: number;
  deviceTypeProps?: DeviceTypeProps;
  disableGTM?: boolean;
  enableMfeDebug?: boolean;
  gtmId: string;
};

export type OwnProps = {
  children: React.ReactNode;
  appProps: AppProps;
};

export default function ForAppWrapper({ children, appProps }: OwnProps) {
  const isSafari = getIsSafari(appProps);

  useEffectOnce(() => {
    initDataDog(appProps.correlationId);
  }, [appProps.correlationId]);

  useMicroFrontend(appProps.enableMfeDebug ?? false);

  useEffect(() => {
    if (isSafari) import('focus-visible');
  }, [isSafari]);

  return (
    <>
      <div
        className="mx-auto w-full max-w-[1800px]"
        data-page-client-id={appProps.clientId}
      >
        {children}
      </div>
      <GoogleTagManager
        disableGTM={appProps.disableGTM}
        gtmId={appProps.gtmId}
        isNative={appProps.deviceTypeProps?.nativeDeviceType?.isNative ?? false}
      />
    </>
  );
}
